import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useGetMentorCalls(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const ChatRestClient = useChatRestClient();
  type MentorCallsResponse = {
    success: boolean;
    [key: string]: any;
  };

  const mutation = useMutation<
    MentorCallsResponse,
    Error,
    {student_id?: string; mentor_id?: string; status?: string}
  >(
    async filters => {
      const queryParams = new URLSearchParams(filters);
      const queryString = queryParams.toString();
      const response = await ChatRestClient.get(
        `subscription/v1/mentor-call?${queryString}`,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data?.success) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
